import {ValidationErrorModel, ValidationResultModel} from '../../_foundation/models/validation.models';
import {
  DailyLogOperationInstance,
  LogComment,
  StepInstance
} from './operation.models';
import { PtLuxonDate } from './date.models';

export enum ErrorType {
  Default,
  Warning,
  Error
}

export enum ActionType {
  OperationGap = 1,
  OperationOverlap = 2,
  Unconfirmed = 3,
  ContractualHierarchy = 4,
  Multiday = 5,
  OpenEnded = 6,
  Timezone = 7,
  Safety = 8,
  Weather = 9,
  DailyLegLoad = 10,
  DailyObservations = 11,
  OperationRule = 12,
  Consumable = 13,
  VesselCrew = 14,
  MorningMinutes = 15,
  VoyageLog = 16,
  DelayPauseOverlap = 17, // for where user has added a delay, paused an op, and then manually set a step time to be overlapping with the pause
  FieldPositioningOutstanding = 18,
  RobFuelFigures = 19
}

export enum PageValidationType {
  DailyLog = 1,
  WeatherReading = 2,
  Safety = 3,
  Consumables = 4,
  VesselCrew = 5,
  JackingActivity = 6,
  DailyObservations = 7,
  DailyLegLoad = 8,
  FieldPositioning = 9,
  MorningMinutes = 10,
  VoyageLog = 11,
  RobFuelFigures = 12,
  OnSiteMovement = 13
}

export class ValidationResult implements ValidationResultModel {
  entityId?: number;
  isValid: boolean = true;
  errors: ValidationError[] = [];

  addError(message: string, errorType: ErrorType, actionType?: ActionType, startAndEnd?: StartAndEnd, pageType?: PageValidationType) {
    const error = new ValidationError();
    error.type = errorType;

    switch (errorType) {
      case ErrorType.Warning:
        error.message = message;
        break;
      case ErrorType.Error:
        this.isValid = false;
        error.message = message;
        break;
      case ErrorType.Default:
        this.isValid = false;
        error.message = message;
        break;
    }

    error.actionType = actionType;
    error.startAndEnd = startAndEnd;
    error.pageValidationType = pageType;

    this.errors.push(error);
  }
}

export class ValidationError implements ValidationErrorModel {
  code?: string;
  property: string;
  message: string; // foundation domain validation result returns error with message under 'message'
  errorMessage: string; // fluent validation result returns error with message under 'errorMessage'
  type: ErrorType;
  actionType: ActionType;
  startAndEnd?: StartAndEnd;
  pageValidationType?: PageValidationType;
}

export class ErrorGroup {
  incompleteSections?: ValidationError[];
  errors: ValidationError[] = [];
  title: string;
  action: ActionType;
  showButtonOverride?: boolean;
}

export class StartAndEnd {
  // used for general operation overlaps
  startTime: PtLuxonDate = new PtLuxonDate();
  endTime: PtLuxonDate = new PtLuxonDate();
  operationInstance?: DailyLogOperationInstance;
  previousOperation?: DailyLogOperationInstance;
  operationInstanceId?: number;
  previousOperatioInstanceId?: number;
  type?: ActionType;

  // steps overlapping with a pause time
  stepInstance?: StepInstance;
  stepName?: string;

  // used where op start/end overlaps with pause time
  operationStartOnlyOverlapTime?: PtLuxonDate;
  operationEndOnlyOverlapTime?: PtLuxonDate;
}

export class HierarchyCollision {
  lowerInstance: DailyLogOperationInstance;
  lowerInstanceTempId?: number;
  higherInstance: DailyLogOperationInstance;
  higherInstanceTempId?: number;
  collisionStart?: PtLuxonDate;
  collisionEnd?: PtLuxonDate;
}

export class ContractualTimeGroup {
  times: StartAndEnd[] = [];
  isContractual: boolean;
  operationInstance?: DailyLogOperationInstance;

  // local only used to overlap validation
  number: number;
}

export class StepTimeError {
  time: PtLuxonDate;
  stepInstance: StepInstance;
}

export class CommentTimeError {
  invalidComment: LogComment;
  errorMessage: string;
}

export class ContractualOperationValidationOptions {
  instance: DailyLogOperationInstance;
  previousOperation: DailyLogOperationInstance;
  difference: number;
  mostRecentTime: PtLuxonDate;
}



// WEBPACK FOOTER //
// ./src/models/projects/validation.models.ts